module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "gwi-developing"
    }
  }, [_c('div', {
    staticClass: "developing"
  }, [_c('p', [_vm._v("正在开发中...")]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("功能正在进行开发，敬请期待")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dabf38ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developing/developing.vue
// module id = 879
// module chunks = 0